import React, { useRef, useEffect, useCallback, useState} from 'react';
import {usePreventDragging} from './preventDragging.js';
import MicroTuningNote from './MicroTuningNote.js';
import MicroTuningFunction from './MicroTuningFunction.js';
import {connect} from 'react-redux';
import '../../MicroTuning.scss';

const NOTES = 64;

const MicroTuningComponent = ({effect}) => { 
    let [position, setPosition] = useState(-32);
    let ref = useRef(undefined);
    let {preventDragging} = usePreventDragging({ref, effect});
    
    let notes = [];
    for (let i=position; i < position + NOTES; i++) {
        notes.push(i);
    }
    return (
        <div
          onMouseDown={() => preventDragging(false)}
          onMouseUp={() => preventDragging(true)}
          ref={ref} className="micro-tuning">
          <div className="notes-container">
          {notes.map(
              note =>
                  <MicroTuningNote effect={effect} note={note}/>)}
          </div>
          <MicroTuningFunction effect={effect}/>
        </div>
    );
}

const mapStateToProps = (state, props) => {
  return {
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(MicroTuningComponent);
